<cap-bsg-header [welcomePage]="'/home/dashboard'" appTitleKey="layouts.page.title" appLogo="{{imagePath}}" alt="Logo">
  <li>
    <cap-user-picker [languages]="['de','fr']"
                     [isICP]="true">
    </cap-user-picker>
  </li>
</cap-bsg-header>

<div class="bsg-content-wrapper">

  <nav id="navigation" [attr.aria-label]="'layouts.page.titleNavigation'|translate">
    <cap-environment-marker></cap-environment-marker>
    <cap-bsg-nav-menu>
      <ng-container *ngFor="let item of root?.children">
        <cap-bsg-nav-item
          [deactivated]="item.deactivated"
          [url]="item.content.link"
          [labelKey]="item.content.text"
          [tooltipKey]="item.content.text"
          [icon]="item.content.icon"
          [style]="item.content.style" [href]="item.content.href" [target]="item.content.target">
          <ng-container *ngFor="let item2 of item?.children">
            <cap-bsg-nav-item
              [deactivated]="item2.deactivated"
              [url]="item2.content.link"
              [labelKey]="item2.content.text"
              [tooltipKey]="item2.content.text"
              [icon]="item2.content.icon"
              [style]="item2.content.style" [href]="item2.content.href" [target]="item2.content.target">
            </cap-bsg-nav-item>
          </ng-container>
        </cap-bsg-nav-item>
      </ng-container>
    </cap-bsg-nav-menu>
  </nav>

  <main id="content" role="main" style="padding-top: 140px">

    <cap-alert-list id="alert-wrapper"></cap-alert-list>

    <form>
      <cap-search-bar></cap-search-bar>
    </form>

    <router-outlet></router-outlet>

  </main>

</div>

